import axios, {AxiosInstance} from 'axios';

/**
 * Portal do cliente (#480058): a tela chama /portal/* do navegador so com a
 * sessao curta (X-Portal-Sessao) que o servidor da plataforma do cliente pediu
 * em POST /portal/sessao. O token-api da plataforma nunca vai ao navegador
 * (docs/plans/processo-projetos/portal-cliente).
 */

export interface Sessao {
    sessao: string,
    /** Quem estava logado na plataforma quando a sessao foi criada (so para exibir). */
    usuario: {nome: string, email: string},
    /** Visualizacao da equipe (#484909): o portal como o cliente ve, so leitura. */
    equipe?: boolean,
}

const CHAVE = 'portal-implantacao-sessao';

/** Sessao guardada na aba: a URL fica limpa e recarregar a pagina continua funcionando. */
export const lerSessao = (): string | null => {
    try {
        return sessionStorage.getItem(CHAVE);
    } catch (e) {
        return null;
    }
};

export const gravarSessao = (sessao: string) => {
    try {
        sessionStorage.setItem(CHAVE, sessao);
    } catch (e) {
        // sem sessionStorage: a sessao vale so enquanto a tela estiver aberta
    }
};

/** Cliente HTTP do portal: quem age ja esta na sessao. */
export const portalApi = (sessao: Sessao): AxiosInstance => axios.create({
    baseURL: process.env.REACT_APP_HOST,
    headers: {'X-Portal-Sessao': sessao.sessao},
});

/** Sessao que a plataforma do cliente passou na URL (#/portal?sessao=...). */
export const sessaoDaUrl = (): string | null => {
    const busca = window.location.hash.split('?')[1] || '';
    return new URLSearchParams(busca).get('sessao');
};

/** Processo pedido na URL (#/portal?processo=...), o do link da equipe. */
export const processoDaUrl = (): number | null => {
    const busca = window.location.hash.split('?')[1] || '';
    return Number(new URLSearchParams(busca).get('processo')) || null;
};

export const erroPortal = (erro: any, padrao: string) => String(erro?.response?.data?.error ?? padrao);

/** Download pelo portal (precisa do cabecalho, entao nao da para ser um link simples). */
export const baixar = (api: AxiosInstance, rota: string, nome: string) =>
    api.get(rota, {responseType: 'blob'}).then(resposta => {
        const url = URL.createObjectURL(resposta.data);
        const link = document.createElement('a');
        link.href = url;
        link.download = nome;
        document.body.appendChild(link);
        link.click();
        link.remove();
        setTimeout(() => URL.revokeObjectURL(url), 2000);
    });
